import React, { ReactElement } from 'react';
import styled from 'styled-components';
import Color from '@styles/Color';

const ValidSec = styled.div`
  color: ${Color.RED_8};
  font-size: 12px;
  font-weight: 700;
  padding: 6px 8px;
  width: 100%;
  text-align: left;
`;

interface ValidMessageProps {
  children: ReactElement | string;
}

function InputValidMessage({ children }: ValidMessageProps) {
  return <ValidSec>{children}</ValidSec>;
}

export default InputValidMessage;
